import React, { Component } from 'react';
import DateTime from 'react-datetime';
import { compose } from 'redux';
import { withSnackbar } from 'notistack';
import moment from 'moment';

import { downloadReports } from 'services/billig-report.service';
import withStyles from '@material-ui/core/styles/withStyles';
import FormControl from '@material-ui/core/FormControl';

// components
import CustomTextField from 'components/CustomTextField/CustomTextField';
import SnackMessage from 'components/Snackbar/SnackMessage';
import Button from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

import styles from 'assets/jss/material-dashboard-pro-react/views/billingReportStyles';

class BillingReportDownload extends Component {

	state = {
		month: null,
		year: null,
	}

	showToastMessage = (message, color = 'danger') => {
		this.props.enqueueSnackbar(message, {
			content: (key, message) => <SnackMessage id={key} message={message} color={color} />,
		});
	}

	downloadPdf = async () => {
		try {
			const { month, year } = this.state;

			const date = moment().month(month).year(year);
			await downloadReports(
				{
					month,
					year,
				},
				date,
			);

			this.showToastMessage('Report has been downloaded successfully!', 'success');
		} catch (error) {
			const message = error.resolvedErrorMessage === 'Not Found'
				? 'There is no data for selected period'
				: error.errorDetails
			this.showToastMessage(message);
		}
	}

	render() {
		const { month } = this.state;
		const { classes } = this.props;
		const thisMonth = moment().startOf('month');

		return (
			<GridContainer className={classes.wrapper}>
				<GridItem xs={12} sm={12} md={12}>
					<GridContainer>
						<GridItem xs={12} sm={12} md={6}>
							<FormControl fullWidth>
								<div className={classes.dateTimeWrapper}>
									<DateTime
										renderInput={(props) =>
											<CustomTextField {...props}
												label="Select Month and Year *"
												margin="normal"
												inputProps={{ readOnly: true }}
											/>}
										value={null}
										isValidDate={(current) => current.isBefore(thisMonth)}
										closeOnSelect={true}
										inputProps={{ fullWidth: true }}
										timeFormat={false}
										dateFormat="MMMM, YYYY"
										onChange={(value) => {
											this.setState({
												month: value.month(),
												year: value.year(),
											});
										}}
									/>
								</div>
							</FormControl>
						</GridItem>
						<GridItem xs={12} sm={12} md={6}>
							<Button
								className={classes.downloadReport}
								size="sm"
								color="warning"
								onClick={this.downloadPdf}
								disabled={!Number.isInteger(month)}
							>
								{'Download Report'}
							</Button>
						</GridItem>
					</GridContainer>
				</GridItem>
			</GridContainer>
		);
	}
}


export default compose(
	withStyles(styles),
	withSnackbar,
)(BillingReportDownload);
